import styled from 'styled-components';
import InfoTooltip from '../InfoTooltip';
import { spaceRight } from '@xbcb/ui-styles';

export const StyledInfoTooltip = styled(InfoTooltip)`
  ${spaceRight}
`;
